import React from 'react';
import { connect } from "react-redux";
import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
import { Grid, Button, Typography, TextField, FormControlLabel, Checkbox, CircularProgress, Link } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Lock from "@material-ui/icons/Lock";
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import StripeInput from '../Stripe/StripeInput';
import { withStyles } from "@material-ui/core/styles";
import { bindActionCreators } from "redux";
import { scroller, Element } from 'react-scroll';

import * as PaymentActions from "../../actions/PaymentActions";

import { SCROLL_OFFSET, STRIPE_TOKEN, PLATFORM_REDIRECT_URL } from "../../constants";
import {  formatPrice, captureStripeInstallmentPayment } from "../../utils";

const stripePromise = loadStripe(STRIPE_TOKEN);

const styles = (theme) => ({
  stripePayBtn: {
    margin: "10px 0",
    height: "3rem"
  },
  agreesContainer: {
    paddingLeft: "19px !important"
  },
  tcs: {
    padding: "14px"
  },
  TC: {
    listStyleType: "none",
    padding: "0",
    margin: "0"
  },
  ssl: {
    display: "grid",
    gridTemplateColumns: "max-content 1fr",
    gridGap: "9px",
    paddingTop: "0 !important",
    paddingBottom: "20px !important"
  },
  cardLogoContainer: {
    display: "grid",
    gridTemplateColumns: "max-content max-content max-content",
    gridTemplateRows: "max-content",
    gridGap: "25px",
    paddingBottom: "0 !important"
  },
  visaContainer: {
    "& img": {
      width: "3.9em",
    }
  },
  masterContainer: {
    "& img": {
      width: "3.9em",
    }
  },
  expressContainer: {
    display: "grid",
    gridTemplateRows: "max-content",
    placeContent: "center",
    "& img": {
      width: "2.8em",
    }
  },
});

const TviTextFiled = withStyles({
  root: {
    "& .MuiInputLabel-root": {
      fontSize: "1.2em",
    },
    "& legend": {
      fontSize: "0.78em",
    },
  },
})(TextField);

class StripeCheckoutForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      agreeOne: false,
      agreeTwo: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateCard = this.validateCard.bind(this);
    this.hasAgreed = this.hasAgreed.bind(this);
  }

  componentDidUpdate = (prevProps) => {
    const { step, paymentMethod } = this.props;
    const { step: prevStep, paymentMethod: prevPaymentMethod } = prevProps;

    if(step !== prevStep || paymentMethod !== prevPaymentMethod)  {
      this.setState({ agreeOne: false, agreeTwo: false });
    }

  }

  handleChange = (event) => {
    if (event.error) this.setState({ error: event.error.message});
    else this.setState({ error: null });
  }

  handleSubmit = async (cardSource) => {
    const { actions, userAccount, orderId } = this.props;

    actions.openSnackbar('success', 'Please Wait...');

    try {
      const { id, owner } = cardSource;
      const { _id } = userAccount;
      const { invoice, subscription } = await captureStripeInstallmentPayment(orderId, { id }, { ...owner, _id });

      if (invoice === false || subscription === false) actions.openSnackbar('error', 'Something went wrong. Please contact us at 03 9018 5438');
      else {
        actions.openSnackbar('success', 'Thank you for your payment');
        setTimeout(() => window.location.replace(PLATFORM_REDIRECT_URL), 2000);
      }
    } catch (error) {
      console.error(error);
      actions.openSnackbar('error', error.message || 'Payment Error');
    } finally {
      actions.setLoading(false);
    }

  }

  hasAgreed = () => {
    const { agreeOne, agreeTwo } = this.state;
    return agreeOne === true && agreeTwo === true;
  }

  validateCard = async (stripe, elements) => {
    const { actions, userAccount } = this.props;

    if (!this.hasAgreed())
      return actions.openSnackbar('error', 'Please accept the Terms & Conditions');

    const { details, email } = userAccount;
    const { fullName, firstName, lastName, contactNumbers } = details;
    const defaultContact = contactNumbers.find(({ isDefault }) => isDefault);
  
    actions.setLoading(true);

    const ownerInfo = {
      type: 'card',
      currency: 'aud',
      owner: {
        name: fullName ? fullName : `${firstName} ${lastName}`,
        email,
        phone:defaultContact.number,
      }
    };

    if(stripe) {
      try {
        const { error, source  } = await stripe.createSource(elements.getElement(CardCvcElement), ownerInfo);

        if (error) {
          this.scrollToElement("element-cc-details-installment");
          this.setState({ error: error.message });
          actions.setLoading(false);
        } else if (source) {
          source.card.billing_email = ownerInfo.owner.email;

          this.handleSubmit(source);
        } else {
          actions.openSnackbar('error', 'Something went wrong. Please contact us at 03 9018 5438');
          actions.setLoading(false);
        }
      } catch (error) {
        console.log('validate card: ', error);
        this.scrollToElement("element-cc-details-installment");
        this.setState({ error: error.message });
        actions.setLoading(false);
      }
    } else actions.openSnackbar('error', 'Something went wrong. Please contact us at 03 9018 5438');
  }

  scrollToElement = (elementName) => {
    scroller.scrollTo(elementName, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: SCROLL_OFFSET
    });
  }

  renderCardLogos = () => {
    const { classes } = this.props;
    return (<>
      <div className={classes.visaContainer}>
        <img src="/media/visa.svg" alt="visa-logo"/>
      </div>
      <div className={classes.masterContainer}>
        <img src="/media/master.svg" alt="master-logo"/>
      </div>
      <div className={classes.expressContainer}>
        <img src="/media/amex.svg" alt="express-logo"/>
      </div>
    </>);
  }

  renderCardDetailsForm = () => {
    const { state, props, handleChange } = this;
    const { classes } = props;
    const { error } = state;

    return (<>
      <Grid item xs={12} className={classes.ssl}>
        <Lock style={{ color: "black" }} fontSize="small"/> <Typography style={{ color: "black" }} variant="body2"><strong>Secured by Stripe.</strong></Typography>
      </Grid>

      <Grid item xs={12}>
        <Element name="element-cc-details-installment">
          <TviTextFiled
            label="Card Number"
            variant="outlined"
            error={error ? true : false}
            required
            fullWidth
            InputProps={{
              inputComponent: StripeInput,
              inputProps: { component: CardNumberElement, onChange: handleChange },
            }}
            InputLabelProps={{ shrink: true }}
          />
        </Element>
      </Grid>

      <Grid item xs={12}>
        <TviTextFiled
          label="Expiry Date"
          variant="outlined"
          error={error ? true : false}
          required
          fullWidth
          InputProps={{
            inputComponent: StripeInput,
            inputProps: { component: CardExpiryElement, onChange: handleChange },
          }}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>

      <Grid item xs={12}>
        <TviTextFiled
          label="CVC"
          variant="outlined"
          error={error ? true : false}
          required
          fullWidth
          InputProps={{
            inputComponent: StripeInput,
            inputProps: { component: CardCvcElement, onChange: handleChange },
          }}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      {error ? 
        <Grid item xs={12}>
          <Alert severity="error">{error}</Alert> 
        </Grid>
      : null}
    </>);
  }

  renderCheckboxes = () => {
    const { state, props } = this;
    const { agreeOne, agreeTwo } = state;
    const unpaidInstallment = props.installments.find(({ paid }) => !paid);
    let nextInstallmentStr = unpaidInstallment ? `$${formatPrice(unpaidInstallment.amount)}` : `$0`;

    if (props.owing && unpaidInstallment) {
      nextInstallmentStr += ` (Remaining $${formatPrice(props.owing - unpaidInstallment.amount)})`;
    }

    return (<>
      <Grid item xs={12}>
        <Grid container  direction="column" justify="flex-start" alignItems="stretch">
          <FormControlLabel
            control={<Checkbox color="primary" checked={agreeOne} onChange={({ target }) => this.setState({ agreeOne: target.checked })} name="agreeOne" />}
            label={<Typography variant="body2">I hereby confirm that I have read, understand and agree to be bound by the terms of these documents. <Link href="https://www.tradeview.com.au/terms-conditions/" target="_blank">Terms and Conditions</Link>, <Link href="https://www.tradeview.com.au/privacy-policy/" target="_blank">Privacy Policy</Link>, <Link href="https://www.tradeview.com.au/disclaimer/" target="_blank">Disclaimer</Link>, <Link href="https://www.tradeview.com.au/financial-services-guide/?_ga=2.215575826.440151372.1594595168-1439122008.1594595168" target="_blank">Financial Services Guide</Link></Typography>}
          />

          <FormControlLabel
            control={<Checkbox color="primary" checked={agreeTwo} onChange={(event) => this.setState({ agreeTwo: event.target.checked })} name="agreeTwo" />}
            label={<Typography variant="body2">I understand that <strong>{nextInstallmentStr}</strong> is an installment payment.</Typography>}
          />
        </Grid>
      </Grid>
    </>);
  }

  render() {
    const { props, validateCard, renderCardDetailsForm, renderCardLogos, renderCheckboxes } = this;
    const { classes, loading, renderTermsAndConditions, renderCartList, installments } = props;
    const unpaidInstallment = installments.find(({ paid }) => !paid);
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
        <Elements stripe={stripePromise}>
          <ElementsConsumer>{({ stripe, elements }) => (
            <Grid container spacing={2}>
              <Grid item xs={12} className={classes.cardLogoContainer}>{renderCardLogos()}</Grid>

              {renderCardDetailsForm()}

              {/* <Grid item xs={12}>{renderTermsAndConditions()}</Grid> */}
              <Grid item xs={12}>{renderCartList()}</Grid> 
    
              <Grid item xs={12}>{renderCheckboxes()}</Grid>
    
              <Grid item xs={12}>
                <Button id="stripe-pay-button" className={classes.stripePayBtn} disabled={!stripe || loading || !unpaidInstallment} type="submit" variant="contained" color="primary" fullWidth onClick={() => validateCard(stripe, elements)} >
                  {loading ? <Typography variant="h5"> <CircularProgress size={20} /> Processing Payment...</Typography> : <Typography variant="h5">Pay</Typography>}
                </Button>
              </Grid>
            </Grid>        
          )}</ElementsConsumer>
        </Elements>
        </Grid>
      </Grid>
    );
  }
}


const mapStateToProps = ({ payment, accountReducer }) => ({
  loading: payment.loading,
  step: payment.step,
  userAccount: accountReducer,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(PaymentActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(StripeCheckoutForm));